import React from "react";
import "./Withdrawal_History.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Withdrawal_History_card from "./Withdrawal_History_card/Withdrawal_History_card";
import No_data from "../../Common/No_data/No_data";

function Withdrawal_History() {
  const navigate = useNavigate();
  return (
    <section className="Withdrawal_History">
      <div className="withdrawal_header History_header">
        <div className="header-left">
          <span className="header_icon">
            <FontAwesomeIcon icon={faFileLines} />
          </span>
          <h4>Withdrawal History</h4>
        </div>
      </div>

      <Withdrawal_History_card status="Completed" badge="Withdraw" />

       <No_data/>

      <div className="text-center">
        <Button
          className="btn-register mb-3"
          onClick={() => navigate("/withdrawal-history")}
        >
          All History
        </Button>
      </div>

      
    </section>
  );
}

export default Withdrawal_History;
